import { createContext, useContext } from "react";

export type ChatDrawerPanel = "chat" | "agent";

interface ChatContextValue {
    isOpen: boolean;
    open: () => void;
    close: () => void;
    toggle: () => void;
    panel: ChatDrawerPanel;
    setPanel: (panel: ChatDrawerPanel) => void;

    // You can extend this later:
    selectedThreadId?: string;
    setSelectedThreadId: (id?: string) => void;
}

export const ChatContext = createContext<ChatContextValue | undefined>(
    undefined,
);

export function useChat(): ChatContextValue {
    const ctx = useContext(ChatContext);
    if (!ctx) {
        throw new Error("useChat must be used within a ChatProvider");
    }
    return ctx;
}
